import { Content, ContentRow, InnerPullToRefresh, type InnerPullToRefreshProps } from '../components'
import { SubPage, type SubPageProps } from './SubPage'

export type SubPageWithRefreshProps = SubPageProps & InnerPullToRefreshProps

/**
 * When your SubPage needs pull to refresh, if not please use `SubPage`
 */
const SubPageWithRefresh = ({ children, disablePullDown = false, onRefresh, ...rest }: SubPageWithRefreshProps) => (
  <SubPage {...rest}>
    <InnerPullToRefresh onRefresh={onRefresh} disablePullDown={disablePullDown}>
      {children}
    </InnerPullToRefresh>
  </SubPage>
)

/**
 * A container where we set the content distance based on the theme correctly.
 *
 * @example <SubPage><SubPage.Content isFullView>your application content</SubPage.Content></SubPage>
 */
SubPageWithRefresh.Content = Content

/**
 * Our mobile version is a full wide screen, this ContentRow can be used when
 * it does need indentation for a specific row. This indentation will only be
 * added on mobile variants.
 * @warning will add indentation only on MOBILE
 */
SubPageWithRefresh.ContentRow = ContentRow

export { SubPageWithRefresh }
